import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { DataGrid } from "@mui/x-data-grid";
import { Paper } from "@mui/material";

import "./Shapes.css";
import { Box } from "@mui/system";
import Divider from "@mui/material/Divider";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllShapes, addShape } from "../../redux/features/shapes.features";
import { showSuccess } from "../../redux/features/alertbox.features";

const initialValues = {
  shapesName: "",
  shapesDescription: "",
  shapesStatus: "Active",
};

const Shapes = () => {
  let dispatch = useDispatch();
  let shapesState = useSelector((state) => {
    return state.shapesReducer;
  });

  let { shapes,shapesAdded } = shapesState;

  const [values, setValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setValues({
      ...values,
      [name]: value,
    });
  };
  React.useEffect(() => {
    if(shapesAdded) dispatch(showSuccess("shapes added successfully"))
  
    
  }, [shapesAdded,dispatch])
  useEffect(() => {
    dispatch(fetchAllShapes());
  }, [dispatch]);

  const columns = [
    // {field:"id",headerName: "ID" },

    { field: "shapesName", headerName: "Shape Name", minWidth: 330, flex: 1 },
    {
      field: "shapesDescription",
      headerName: "shape Description",
      minWidth: 330,
      flex: 1,
    },
    {
      field: "shapesStatus",
      headerName: "shape Status",
      minWidth: 330,
      flex: 1,
      renderCell: (cellValues) => {
        return (
          <Button
            variant="contained"
            color={
              cellValues.row.shapesStatus === "Active" ? "primary" : "error"
            }
            onClick={(event) => {}}
          >
            {cellValues.row.shapesStatus}
          </Button>
        );
      },
    },
  ];

  return (
    <div>
      <div className="row">
        <div className="col-12 container">
          <div className="row">
            <div className="col-6">
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="Shape Name"
                placeholder="Cushion.."
                defaultValue=""
                color="warning"
                name="shapesName"
                value={values.shapesName}
                onChange={handleChange}
              />

              <CustomSelectBox
                items={["Active", "DeActive"]}
                onChange={handleChange}
                title="Status"
                name="shapesStatus"
                value={values.shapesStatus}
              />
            </div>
            <div className="col-6">
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                multiline={true}
                rows={4}
                id="outlined-required"
                label="Shape Description"
                placeholder="Describe about the gem shape"
                defaultValue=""
                color="warning"
                name="shapesDescription"
                value={values.shapesDescription}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="col-8"></div>
        <div className="col-4">
          <ButtonGroup
            fullWidth
            variant="contained"
            aria-label="outlined primary button group"
          >
            <Button color="warning">Cancel</Button>
            <Button onClick={() => dispatch(addShape(values))} color="success">
              Save
            </Button>
          </ButtonGroup>
        </div>

        <div style={{ padding: 20 }} className="col-12">
          <Divider style={{ marginBottom: 20 }}>Shapes List</Divider>
          <Box component={Paper} style={{ height: 350 }} className="">
            <DataGrid
              // getRowId={row => row._id}
              filterMode="client"
              rows={shapes}
              columns={columns}
              pageSize={15}
              rowsPerPageOptions={[15]}
              density="comfortable"
              className="col-12"
              autoPageSize
            />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Shapes;
